// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import * as Yup from 'yup';
// import { useFormik } from "formik";
// import { handleSignIn } from '../../modules/authModules.ts';

// const SignIn = () => {
//     const [userLogin, setUserLogin] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const navigate = useNavigate();

//     const validation = useFormik({
//         enableReinitialize: true,
//         initialValues: {
//             email: userLogin.email,
//             rememberMe: userLogin.rememberMe
//         },
//         validationSchema: Yup.object({
//             email: Yup.string().required('Please Enter Your User ID')
//         }),
//         onSubmit: async (values, { setSubmitting, setErrors }) => {
//             setLoading(true)
//             try {
//                 await handleSignIn(values.email, navigate, setLoading);
//             } finally {
//                 setSubmitting(false);
//             }
//         },
//     });

//     return (
//         <div className="min-h-screen flex flex-col sm:flex-row bg-[#F6FAF9]">
//             <div className="flex-1 flex items-center justify-center p-4">
//                 <div className="w-full max-w-md p-4 sm:p-6 md:p-8 bg-white shadow-md rounded-lg">
//                     <div className="mb-6 space-y-2">
//                         <h2 className="text-xl sm:text-2xl font-semibold text-center">
//                             Welcome Back
//                         </h2>
//                         <p className="text-gray-500 text-sm sm:text-base text-center">
//                             Enter your username and password to continue
//                         </p>
//                     </div>

//                     <form onSubmit={validation.handleSubmit} className="space-y-4">
//                         <div>
//                             <label className="block text-sm font-medium py-2">Username</label>
//                             <input
//                                 type="text"
//                                 name="email"
//                                 className={`w-full px-4 py-2 border rounded-md focus:outline-none ${validation.touched.email &&
//                                     validation.errors.email
//                                     ? "border-red-500"
//                                     : "focus:ring-2 focus:ring-blue-500"
//                                     }`}
//                                 value={validation.values.email}
//                                 onChange={validation.handleChange}
//                                 onBlur={validation.handleBlur}
//                             />
//                             {validation.touched.email &&
//                                 validation.errors.email && (
//                                     <p className="text-red-500 text-sm">
//                                         {validation.errors.email}
//                                     </p>
//                                 )}
//                         </div>

//                         <div className="flex items-center justify-between text-sm">
//                             <div className="flex items-center font-semibold">
//                                 <input
//                                     type="checkbox"
//                                     name="rememberMe"
//                                     className="mr-2"
//                                     checked={validation.values.rememberMe}
//                                     onChange={validation.handleChange}
//                                 />
//                                 Remember me
//                             </div>
//                             {/* <a href="#" className="font-semibold hover:underline">
//                   Forgot Password?
//                 </a> */}
//                         </div>

//                         <button
//                             type="submit"
//                             className="w-full bg-[#003950] text-white py-2.5 rounded-md hover:bg-[#002d3d] transition-colors duration-200 text-sm font-medium"
//                             disabled={(validation.isSubmitting || loading)}
//                         >
//                             {(validation.isSubmitting || loading) ? "Signing in..." : "Sign In"}
//                         </button>
//                     </form>

//                     {/* <p className="mt-6 text-center text-sm text-gray-500">
//             {isLogin ? "Don't have an account? " : "Already have an account? "}
//             <button
//               onClick={() => setIsLogin(!isLogin)}
//               className="text-[#003950] font-medium hover:underline"
//             >
//               {isLogin ? "Register" : "Login"}
//             </button>
//           </p> */}
//                 </div>
//             </div>

//             <div
//                 className="hidden md:flex flex-1 items-center justify-start text-white m-4 rounded-xl"
//                 style={{ backgroundColor: "#003950" }}
//             >
//                 <div className="md:p-0">
//                     <h1 className="text-[290px] font-bold opacity-20 leading-none lg:pl-8 md:pl-0">
//                         ML
//                     </h1>
//                     <h2 className="lg:text-5xl md:text-3xl font-semibold lg:pl-12 md:pl-2">
//                         Machine Learning
//                     </h2>
//                     <p className="mt-4 md:text-2xl lg:text-3xl font-semibold lg:pl-12 md:pl-3">
//                         Transforming Data into Intelligence
//                     </p>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default SignIn;

import React, { useState } from 'react';
import {
    Card,
    CardBody,
    Col,
    Container,
    Input,
    Label,
    Row,
    Button,
    Form,
    FormFeedback,
    Spinner
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { ToastContainer } from 'react-toastify';
import { handleSignIn } from '../../modules/authModules.ts';
import ParticlesAuth from './ParticlesAuth.tsx';

const SignIn = () => {
    const [userLogin, setUserLogin] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: userLogin.email,
            rememberMe: userLogin.rememberMe
        },
        validationSchema: Yup.object({
            email: Yup.string().required('Please Enter Your User ID')
        }),
        onSubmit: async (values, { setSubmitting, setErrors }) => {
            setLoading(true)
            try {
                await handleSignIn(values.email, navigate, setLoading);
            } finally {
                setSubmitting(false);
            }
        },
    });

    return (
        <ParticlesAuth>
        <div className='auth-page-content'>
            <Container>
                <ToastContainer position='top-center' />
                <Row className='justify-content-center'>
                    <Col md={8} lg={6} xl={5}>
                        <Card className='login-box'>
                            <CardBody className='p-4'>
                                <div className='text-center mt-2'>
                                    <h5 className='text-main-color'>Welcome Back !</h5>
                                    <p className='text-muted'>Sign in to continue</p>
                                </div>
                                <div className='p-2 mt-4'>

                                    <Form
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}
                                        action='#'
                                    >
                                        <div className='mb-3'>
                                            <Label htmlFor='email' className='form-label'>
                                                User ID
                                            </Label>
                                            <Input
                                                name='email'
                                                className='form-control'
                                                placeholder='Enter User ID'
                                                type='text'
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.email || ''}
                                                invalid={
                                                    validation.touched.email && validation.errors.email
                                                        ? true
                                                        : false
                                                }
                                            />
                                            {validation.touched.email && validation.errors.email ? (
                                                <FormFeedback type='invalid'>
                                                    {validation.errors.email}
                                                </FormFeedback>
                                            ) : null}
                                        </div>
                                        <div className='mt-1'>
                                            <Button
                                                className='btn bg-secondary w-100 mt-2'
                                                type='submit'
                                                disabled={loading}
                                            >
                                                {loading ? (
                                                    <Spinner size='sm' className='me-2'>
                                                        Loading...
                                                    </Spinner>
                                                ) : null}
                                                Sign In
                                            </Button>
                                        </div>
                                    </Form>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
        </ParticlesAuth>
    );
};

export default SignIn;
